import { useTableFiltersQuery } from '@modules/layout/hooks';

import type { TableFiltersQuery } from '@modules/layout/hooks';

export type LapsTableFilters = {
    courseId?: string;
};

export type LapsTableFiltersQuery = Omit<TableFiltersQuery, 'filters'> & {
    filters: TableFiltersQuery['filters'] & LapsTableFilters;
};

const useLapsTableFiltersQuery = (): LapsTableFiltersQuery => {
    const { filters, query, ...otherTableFiltersQuery } = useTableFiltersQuery();

    const result: LapsTableFiltersQuery = {
        filters: {
            ...filters,
            courseId: query.courseId ? String(query.courseId) : undefined,
        },
        query,
        ...otherTableFiltersQuery,
    };

    return result;
};

export { useLapsTableFiltersQuery };
